<template>
    <div class="page">
        <public-head title="分类招生"></public-head>
        <div class="header">
            <van-swipe :autoplay="3000" indicator-color="white" class="van-swipe">
            <van-swipe-item v-for="(item,index) in banners" :key="index" @click="bannerDetail(item)">
                <img :src="item.ad_code" />
            </van-swipe-item>
        </van-swipe>
            <div class="search" @click="$router.push('/fenlei/search?go='+1)">
                <img
                    class="search-icon"
                    src="https://new.schoolpi.net/attach/small_program/search/search_icon.jpg"
                />
                <input class="search-input" placeholder="请输入院校名称" disabled="disabled" />
            </div>
            <div class="verb">{{days}}</div>
        </div>
        <div class="menu">
            <div class="menu-item">
                <div @click="$router.push('/fenlei/policy')">
                    <img
                        src="https://new.schoolpi.net/attach/small_program/class/book.png"
                        class="menu-logo"
                    />
                    <div class="menu-name">报考政策</div>
                </div>

                <div @click="$router.push('/fenlei/allSchool')">
                    <img
                        src="https://new.schoolpi.net/attach/small_program/class/Careerplanning.png"
                        class="menu-logo"
                    />
                    <div class="menu-name">全部院校</div>
                </div>

                <div @click="$router.push('/fenlei/hostSubject')">
                    <img
                        src="https://new.schoolpi.net/attach/small_program/class/Colleges.png"
                        class="menu-logo"
                    />
                    <div class="menu-name">热门专业</div>
                </div>

                <div @click="$router.push('/fenlei/historySubject')">
                    <img
                        src="https://new.schoolpi.net/attach/small_program/class/Itembank.png"
                        class="menu-logo"
                    />
                    <div class="menu-name">历年真题</div>
                </div>

                <div @click="$router.push('/fenlei/historySchool')">
                    <img
                        src="https://new.schoolpi.net/attach/small_program/class/siginup.png"
                        class="menu-logo"
                    />
                    <div class="menu-name">历年数据</div>
                </div>
            </div>
        </div>

        <div class="hot-school">
            <div class="title">热门院校</div>
            <!--  -->
            <van-list class="school-list" finished-text="没有更多了" @load="onLoad" :finished="finished">
                <div
                    class="school-item"
                    v-for="(item,index) in hostList"
                    :key="index"
                    @click="goHostDetail(item)"
                >
                    <img :src="item.thumb" class="school-logo" />
                    <div class="school-name">{{item.name}}</div>
                    <div class="school-type">学校类型:{{item.institution_type[0]}}</div>
                    <div class="school-area">{{item.province}}{{item.city}}</div>
                </div>
                <div class="last"></div>
            </van-list>
        </div>
    </div>
</template>

<script>
import PublicHead from "../../components/publicHead";
import { httpPost } from "../../axios/index";
export default {
    data() {
        return {
            banners: "", //首页轮播图
            days: "",
            num: 12,
            page: 1,
            hostList: [], //热门学校
            policyList: [], //报考政策
            cheer_id: "0", //分类的id
            page: 1,
            finished:false
        };
    },
    created() {},
    methods: {
        // 点击进入banner图详情
        bannerDetail(item){
            if(item.media_nw===1){
                this.$router.push(item.h5_link)
            } 
        },
        // 上拉加载
        onLoad() {
            this.page = this.page + 1;
            httpPost("/classifie/school_hot", {
                province: this.$store.state.areaInfo.pid,
                page: this.page
            }).then(res => {
                if (res.code === 1) {
                    this.hostList = [...this.hostList, ...res.list];
                    this.$toast.loading({
                        message: "加载中...",
                        forbidClick: true
                    });
                } else {
                    this.finished=true;	
                }
            });
        },
        //进入热门院校详情
        goHostDetail(e) {
            this.$router.push({
                path: "/fenlei/HostDetail",
                query: {
                    sid: e.id
                }
            });
        },
        // 获取距离高考天数数据
        fetchNum(){
             httpPost("/classifie/index", {
                province: this.$store.state.areaInfo.pid
            }).then(res => {
              
                if (res.code === 1) {
                    this.days = res.list.str;
                }
            });
        },
        // 获取首页banner
        fetchbanner() {
            httpPost("/ad/rotation_class", {
                province: this.$store.state.areaInfo.pid
            }).then(res => {
                if (res.code === 1) {
                    this.banners = res.banlist
                }
            });
        },
        // 获取热门院系数据
        fetchHostSchool() {
            httpPost("/classifie/school_hot", {
                province: this.$store.state.areaInfo.pid,
                page: this.page,
                num: this.num
            }).then(res => {
             
                if (res.code === 1) {
                    this.hostList = res.list;
                }
            });
        }
    },
    mounted() {
        this.fetchNum();
        this.fetchbanner();
        this.fetchHostSchool();
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
.van-list>>>.van-list__finished-text{
    width: 100%;
}
.page {
    background: #f2f2f2;
    color: #000;
}
.van-swipe{
    width: 100%;
}
.van-swipe img{
    width: 100%;
    height: 18.75rem;
}
.last {
    width: 6.875rem;
}
.header {
    position: relative;
    margin-top: 46px;
}
.banner {
    height: 15.625rem;
    /* background: red; */
    border-bottom-right-radius: 15%;
    width: 100%;
}

.search {
    position: absolute;
    width: 21.5625rem;
    height: 2.1875rem;
    margin: 0 auto;
    top: 0.9375rem;
    left: 0;
    right: 0;
    background-color: #ffffff;
    border-radius: 1.0625rem;
    opacity: 0.5;
    display: flex;
}
.search-icon {
    width: 0.9375rem;
    height: 0.9375rem;
    margin: auto 0.9375rem;
    /* border: 1px blue solid; */
}
.search-input {
    color: #a9a9a9;
    margin: auto 0;
    border: 0;
    opacity: 0.4;
}
.verb {
    position: absolute;
    bottom: -1.625rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 18.75rem;
    height: 3.4375rem;
    background-color: #ffffff;
    border-radius: 1.625rem;
    text-align: center;
    line-height: 3.4375rem;
    font-size: 1rem;
    color: #000000;
    box-shadow: 10px 3px 10px 3px #ccc;
}
.verb text {
    font-size: 1.375rem;
    display: inline-block;
    padding: 0 10px;
}
/* 菜单 */
.menu {
    padding: 3.75rem 0 1.5625rem 0;
    background: #fff;
}
.menu-item {
    width: 100%;
    display: flex;
    justify-content: space-around;
    box-sizing: border-box;
    padding: 0 0.625rem;
    font-size: 0.6875rem;
}
.menu-logo {
    width: 3.125rem;
    height: 3.125rem;
    margin: 0 auto;
}
/* 热门院校 */
.hot-school {
    background: #fff;
    margin-top: 0.625rem;
}
.title {
    font-size: 1.125rem;
    padding: 0.9375rem 0.625rem;
}
.school-list {
    width: 21.875rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
/* .school-list:after {
    content: "";
    flex: auto;
    margin-right: 5px;
 } */
.school-item {
    width: 32%;
    font-size: 0.75rem;
    margin-top: 0.625rem;
    border-radius: 10px;
    box-sizing: border-box;
    margin-bottom: 0.625rem;
    border: 1px solid #ccc;
    padding: 0.3125rem;
    box-shadow: 0 6px 10px 6px #eaeaea;
}
.school-last {
    border: 0;
}
.school-logo {
    height: 6.875rem;
    width: 6.25rem;
    border-radius: 10rpx;
}
.school-name,
.school-type,
.school-area {
    padding-left: 0.1875rem;
    color: #a9a9a9;
}
.school-name {
    font-size: 0.875rem;
    padding: 0.25rem 0.1875rem;
    color: #000;
}
</style>